<template>
  <custom-dialog width="1100px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="item-title">{{ $t('dms_out_stock_dialog.mu_biao_xin_xi') }}</div>
      <el-form :model="form" :inline="true" ref="form" :rules="rules" label-width="110px" label-position="top">
        <el-form-item :label="$t('dms_out_stock_dialog.fa_huo_ding_dan_hao')" prop="shipmentNum">
          <el-input v-model="form.shipmentNum" style="width: 240px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_out_stock_dialog.xian_fa_wang_guo_jia')" prop="placeCode">
          <custom-select url="factoryDeliveryPlaceSelectList" v-model="form.placeCode" :props="{ label: 'placeName', value: 'placeCode' }" @change="onPlaceCodeChange"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_out_stock_dialog.xianISTzhan_dian')">
          <el-input disabled :value="form.websiteName"></el-input>
        </el-form-item>
      </el-form>
      <div class="item-title">{{ $t('dms_out_stock_dialog.she_bei_xin_xi') }}</div>
      <custom-table index :data="model.rows" tableCode="stock_device_out"></custom-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        shipmentNum: '',
        hqName: '',
        stockFactoryId: [],
        domainUrl: '',
        websiteId: '',
        websiteName: '',
        websiteCode: '',
        // 现发往国家
        placeCode: '',
      },
    };
  },
  mounted() {},

  computed: {
    rules() {
      return {
        shipmentNum: { required: true, message: this.$t('dms_out_stock_dialog.qsrfhddh') },
        placeCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    selectChange: function (item) {
      this.form.domainUrl = item.domainUrl;
      this.form.hqName = item.orgName;
      this.form.websiteId = item.websiteId;
      this.form.websiteName = item.websiteName;
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.stockFactoryId = this.model.rows.map(t => t.stockFactoryId);
        this.$postJSON(apis.FactoryStockShip, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.clearKeepAlive('stockManage');
          this.$emit('success');
          this.visible = false;
        });
      });
    },
    onPlaceCodeChange(data) {
      this.form.websiteName = data.websiteName;
      this.form.websiteCode = data.websiteCode;
    },
  },
};
</script>

<style lang="scss"></style>
